import { authorizedApi } from './index';

export const sponsorApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    broadcastTransaction: builder.mutation({
      query: ({ serializedTransaction }) => ({
        url: '/gas-sponsor/broadcast-transaction',
        method: 'POST',
        body: {
          serializedTransaction,
        },
      }),
    }),
    getAccountCreationInstructions: builder.query({
      query: ({ tokenAddress }) => ({
        url: `/gas-sponsor/create-account-instructions`,
        method: 'POST',
        body: {
          tokenAddress,
        },
      }),
    }),
    getUnwrapSolInstructions: builder.query({
      query: () => ({
        url: `/gas-sponsor/create-unwrap-sol-instructions`,
        method: 'POST',
      }),
    }),
    sponsorTransaction: builder.mutation({
      query: ({ serializedTransaction }) => ({
        url: '/gas-sponsor/set-fee-payer',
        method: 'POST',
        body: {
          serializedTransaction,
        },
      }),
    }),
  }),
});

export const {
  useBroadcastTransactionMutation,
  useSponsorTransactionMutation,
  useLazyGetAccountCreationInstructionsQuery,
  useLazyGetUnwrapSolInstructionsQuery,
} = sponsorApi;
